import { Heading, List } from '@chakra-ui/react';
import { useOutletContext } from 'react-router-dom';
import { IOutletContext } from '../../../../../types';
import { IRecordedInterviewScores, IRecordedInterviewQuestion } from 'types';
import { isArray, isString } from 'lodash';
import Question from './Question';
import { getDecryptedQuestions } from '../../helpers';
import { useTranslation } from "react-i18next";

export default function Questions() {
    const { t } = useTranslation('common');
  const { interview, canEditScoresAndAssessment, canViewScoresAndAssessment } = useOutletContext<IOutletContext>();

  const questionsData = interview.scores;
  const encryptedQuestions = interview.questions;

  if (!isString(encryptedQuestions)) return null;

  const questions = getDecryptedQuestions(encryptedQuestions);

  return (
    <>
      <Heading as="h2" fontSize="xl" mt="2" mb="6">
        {t('common:questions')}
                    </Heading>

      <List>
        {questions.map(renderQuestions(canEditScoresAndAssessment, canViewScoresAndAssessment, questionsData))}
      </List>
    </>
  );
}

const renderQuestions =
  (
    canEditScoresAndAssessment: boolean,
    canViewScoresAndAssessment: boolean,
    questionsData?: IRecordedInterviewScores[],
  ) =>
  (question: IRecordedInterviewQuestion, index: number) => {
    const { question: originalQuestion, description, isScored } = question;

    const questionString: string = isArray(originalQuestion)
      ? originalQuestion.join(' ')
      : (question.question as string);

    const questionStringWithDescription = description ? questionString.concat(' ', description) : questionString;
    const data = (isArray(questionsData) ? questionsData : []).find(
      questionData => questionData.question === questionStringWithDescription,
    );

    return (
      <Question
        key={data ? data.questionNo : index + 1}
        index={index}
        question={questionStringWithDescription}
        data={data}
        isScored={isScored}
        canEditScoresAndAssessment={canEditScoresAndAssessment}
        canViewScoresAndAssessment={canViewScoresAndAssessment}
      />
    );
  };
